import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import BeforeLoginLayout from "../layouts/beforeLoginLayout";

const PublicRoute = () => {
  const isAuthenticated = sessionStorage.getItem("mhet_cnd_token");
  const project = sessionStorage.getItem("mhet_cnd_project") || "mhcet";

  return isAuthenticated ? (
    <Navigate to={`/${project}/home`} replace />
  ) : (
    <BeforeLoginLayout>
      <Outlet /> 
    </BeforeLoginLayout>
  );
};

export default PublicRoute;
